import { createFileRoute } from '@tanstack/react-router';
import { DepartmentsListPage } from '@/pages/organization/departments/DepartmentsListPage';
import { dataTableSearchSchema } from '@/lib/validation/dataTableSearchSchema';

export const Route = createFileRoute('/$slug/organization/departments/')({
  component: DepartmentsListPage,
  validateSearch: dataTableSearchSchema({})
});
